import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import CONFIG from '../../../../config';
import useGetApi from '../../../../api/useGetApi';
import Loader from './Loader';
import { useState } from 'react';
import styles from './ShowAllBranches.css';
import {trackWebEngageEvent, params as webengage_params} from '../../../../utils/customWebengageEvents'

const containerStyle = {
    width: '100%',
    height: '400px'
};

const ShowAllBranches = () => {

    const { isLoaded } = useJsApiLoader({
        id: CONFIG.GOOGLE_MAPS_ID,
        googleMapsApiKey: CONFIG.GOOGLE_MAPS_API_KEY
    });

    const {
        data: allCenters,
        loading,
        error,
        setEnabled: fetchAllCentersLocation,
    } = useGetApi(CONFIG.GET_ALL_CENTERS_LOCATION, '', true);
    //set branch data when particular map pin is clicked
    const [selectedMarker, setSelectedMarker] = useState("");

    const mapsWebengageEvent = (opt) => {
        let centerParam = JSON.parse(JSON.stringify(webengage_params));
        centerParam = {
            ...centerParam,
            center_name: opt?.branch_title,
            center_address: opt?.branch_address,
            center_code: opt?.center_code,
            center_phone_numbers: opt?.contact_numbers?.replace(/[\r\n\\]+/g, '')
        }
        trackWebEngageEvent('Anthe_db_faq_geographic',centerParam);
    };

    return (
        <div>
            {/* when map is loaded == true && centers api loading == false*/}
            {(isLoaded && !loading) ? (
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={CONFIG.MAPS_CENTER}
                    zoom={4}
                >
                    {allCenters?.data?.map((location, index) => (
                        <Marker key={index} position={{
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng)
                        }} onClick={() => {
                            setSelectedMarker(location);
                            mapsWebengageEvent(location);
                        }} />
                    ))}
                    {/* Show branch info on click of a pin */}
                    {selectedMarker && (
                        <InfoWindow position={{
                            lat: parseFloat(selectedMarker.lat),
                            lng: parseFloat(selectedMarker.lng)
                        }} onCloseClick={() => setSelectedMarker(null)}>
                            <div>
                                <h3>Branch Name: &nbsp; {selectedMarker.branch_title}</h3>
                                <h3>Branch Address: &nbsp; {selectedMarker.branch_address}</h3>
                            </div>
                        </InfoWindow>
                    )}
                </GoogleMap>
            ) : (
                <Loader />
            )}
        </div>

    );
}
export default ShowAllBranches;